module.exports = __webpack_public_path__ + "img/s3.13aef35a.png";